export const img_path="/"
export const base_path="/"
export const REACT_APP_API_BASE_URL="https://hrms-api.logbinary.com/api"
export const REACT_APP_NODE_API_BASE_URL="https://hrms-api-v2.logbinary.com/api"
export const REACT_APP_CAREER_API_BASE_URL = "https://jobs.logbinary.com"; // NEW